import React from "react";
import ReactDOM from "react-dom/client"; // 'react-dom/client' en lugar de 'react-dom'
import App from "./App";

// Crear un "root" para la aplicación
const root = ReactDOM.createRoot(document.getElementById("root"));

// Renderizar la aplicación en el root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);